/*
  BEELINE MOQ GUARD (2026-10-21, Luke: "enforce the 12 pair min"; the manufacturer's minimum is how we sell).

  The product page steps by custom.minimum_quantity and the cart page footer (main-cart-footer.liquid) holds
  Checkout while any line is below it or off the multiple. This script covers the rest:
   1. "Round up and continue" on the cart page sets each flagged line to the quantity shown, then reloads.
   2. Any other "Check out" (the add-to-cart popup) first asks the server for the cart's minimums
      (sections/beeline-moq-data.liquid). If a line is short, the buyer goes to the cart page to see why.
  A failed lookup lets checkout continue: a network blip must not stop a sale. The B2B Hub checkout
  enforces MOQ on its own. Rollback: remove this file's <script> tag from layout/theme.liquid.
*/
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function short(line) {
    return line.qty < line.min || line.qty % line.step !== 0;
  }

  function cartLines() {
    return fetch(root + 'cart?section_id=beeline-moq-data', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('moq ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-beeline-moq]');
        if (!el) throw new Error('moq data missing');
        return JSON.parse(el.textContent).lines;
      });
  }

  // 1. Round-up button (rendered by main-cart-footer.liquid, re-rendered on every cart change).
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-beeline-moq-fix]');
    if (!btn) return;
    event.preventDefault();
    var items = btn.closest('[data-beeline-moq-notice]').querySelectorAll('li[data-key]');
    var updates = {};
    items.forEach(function (li) { updates[li.dataset.key] = parseInt(li.dataset.to, 10); });
    btn.disabled = true;
    btn.textContent = 'Updating…';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).finally(function () { window.location.reload(); });
  });

  // 2. Checkout from anywhere other than the cart page footer.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    var isCheckout = (submitter && submitter.name === 'checkout') ||
      (!submitter && form.querySelector('[name="checkout"]'));
    if (!isCheckout || form.id === 'cart' || form.dataset.moqChecked === '1') return;
    event.preventDefault();
    var go = function () {
      form.dataset.moqChecked = '1';
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = '';
      form.appendChild(hidden);
      form.submit();
    };
    cartLines()
      .then(function (lines) {
        if (lines.some(short)) window.location.href = root + 'cart';
        else go();
      })
      .catch(go);
  }, true);
})();
